export const useDialogHandler = (dialogHandler) => {
  const openAlert = ({ message, redirectTo, replaceTo }) => {
    if (dialogHandler && dialogHandler.openAlert)
      dialogHandler.openAlert({ message, redirectTo, replaceTo });
  };

  return {
    openAlert,
  };
};
